<template>
  <v-app id="inspire app">
    <Menu id="topH"></Menu>
    <router-view id="view" />
    <icon-chatbot :initOpenProp="false"></icon-chatbot>
    <foot></foot>
  </v-app>
</template>

<script>
/* eslint-disable */
import Menu from "./components/header/Menu.vue";
import Foot from "./components/footer/Footer.vue";
import IconChatbot from "./components/chatbot/iconChatbot.vue";
export default {
  components: {
    Menu,
    Foot,
    IconChatbot,
  },
};
</script>
<style>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: darkgrey;
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 20px orange;
}

.container {
  min-width: 100%;
}

.pads {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1.745em;
  background-color: white;
  padding: 2em;
}

h1 {
  text-align: center;
}

#nl {
  margin-bottom: 1em;
}

body {
  background-color: #f2f6fa;
  overflow-y: auto;
  overflow: auto;
  font-family: "Amatic SC", cursive;
}

p {
  font-family: "Open Sans";
}

.v-application--wrap {
  background-color: white;
}

.v-toolbar__content {
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.v-application--wrap {
  min-height: 100% !important;
}

html {
  overflow-y: auto !important
}
</style>

